import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, withRouter } from "react-router-dom";
import Login from "./pages/user/login/login";
import LoginDomain from "./pages/user/login/loginDomain";
import SwitchUserClient from "./pages/user/login/switchUserClient";
import PasswordReset from "./pages/user/password-reset/password-reset";
import Dashboard from './pages/dashboard/dashboard';
import Sites from './pages/sites/sites'
import Meters from './pages/meters/meters'
import Waste from './pages/waste/waste'
import HH from './pages/hh/hh'
import SupplierInvoices from './pages/supplier-invoices/supplier-invoices'
import Documents from './pages/documents/documents'
import UserGuides from './pages/documents/userguides'
import VideoGuideList from './pages/documents/videoguidelist';
import UserPolicy from './pages/documents/userpolicy'
import Reports from './pages/reports/reports'
import ServiceManagement from './pages/service-management/service-management'
import DataMaps from './pages/DataMaps/datamaps'
import DataMapsAdmin from './pages/DataMaps/datamapsadmin'
import Budgets from './pages/budgets/budgets'
import Contracts from './pages/contracts/contracts'
import Triggers from './pages/triggers/triggers'
import Procurement from './pages/procurement/procurement-centre'
import HHDataCentre from './pages/hh/hh-centre'
import CotQueue from './pages/sites/cots-queue'
import AboutPage from './pages/about/AboutPage'
import DiagnoseConnection from './pages/user/DiagnoseConnection'
import CotsClientManager from './pages/clientmanager/cots-client-manager'

import ClosingPrices from './pages/closing-prices/closing-prices'
import UserManagement from './pages/user/manage-users/manage-users'
import BudgetReport from './pages/reports/budget-report'
import { toast } from 'react-toastify';
import { AuthService } from "./services/auth-service";
import EmptyLayout from "./layouts/empty-layout"
import DefaultLayout from "./layouts/default-layout"
import * as Chart from "chart.js"
import CookiePolicy from "./pages/policys/cookiepolicy"

import "./styles/third-party.scss";
import ClientSelector from "./pages/user/accounts/client-selector";
import LoginSSO from "./pages/user/login/loginSSO";

import PasswordChange from "./pages/user/password-change/password-change";
import { Redirect, Route } from "react-router";
import Site from "./pages/sites/site";

import { msalConfig, jllSSOConfig } from "./authConfig";

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { Security, LoginCallback} from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import ReactGA from 'react-ga';
import { registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import LogoutPage from './pages/user/login/LogoutPage';
import { BreadcrumbProvider } from './components/header/breadcrumbcontext';
import { StickyContainer } from 'react-sticky';


const pca = new PublicClientApplication(msalConfig);
const TRACKING_ID = " UA-216678249-1"; // YOUR_OWN_TRACKING_ID
  const oktaAuth = new OktaAuth(jllSSOConfig);

class App extends Component {

    constructor(props) {
        super(props);
        toast.configure();

        Chart.defaults.global.defaultFontFamily = "Titillium Web";
        ReactGA.initialize(TRACKING_ID);

        

        registerPlugin(FilePondPluginFileValidateSize);
        registerPlugin(FilePondPluginFileValidateType);


        

        this.authService = new AuthService();
        this.state = this.generateAuthState();
         this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
             props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
             window.location.reload();
         };
    }

    generateAuthState = () => {

        const customerId = this.authService.getUserData(AuthService.CUSTOMER_ID_KEY);
        return {
            isAuthenticated: this.authService.getUserData(AuthService.VALID_KEY) || false,
            hasAccount: customerId !== 0,
            customerId: customerId || "",
            userToken: this.authService.getUserData(AuthService.TOKEN_KEY) || "",
            isCustomerSSO: this.authService.getUserData(AuthService.ISSSO) || false
        };
    };

    setupAuthState = () => {
        const authState = this.generateAuthState();
        this.setState(authState);
        if (!authState.hasAccount) {
            this.props.history.push("/client-selection");
            window.location.reload();
        }
    };

    onSelectedClient = (data) => {

        const clientId = data.clientId;
        this.authService.changeCustomer(clientId, data.name);
        this.setState({ hasAccount: true, customerId: clientId }, () => {
            this.props.history.push("/");
            window.location.reload();
        });
    };



    render() {
        return (
            <MsalProvider instance={pca}>
                <div className="App">
                <StickyContainer >
                <BreadcrumbProvider>
                    <Router>
                        {this.state.isAuthenticated && this.state.hasAccount ? (
                            <DefaultLayout>
                                <Switch>
                                    <Dashboard exact path="/" customerId={this.state.customerId} />
                                    <Sites path="/sites" customerId={this.state.customerId} />
                                    <Site path="/site" customerId={this.state.customerId} />
                                    <Meters path="/meters" customerId={this.state.customerId} />
                                    <Waste path="/waste" customerId={this.state.customerId} />
                                    <HH path='/hh/' customerId={this.state.customerId} />
                                    <SupplierInvoices path='/supplier-invoices/' customerId={this.state.customerId} />
                                    <Documents path="/documents" customerId={this.state.customerId} />
                                    <UserGuides path="/userguides" customerId={this.state.customerId} />

                                    <VideoGuideList path="/videoguides" customerId={this.state.customerId} />
                                    
                                    <CotsClientManager path="/cotsclientmanager" customerId={this.state.customerId} />

                                    <UserPolicy path="/userpolicy" customerId={this.state.customerId} />

                                    <DiagnoseConnection path="/diagnoseconnection"/>

                                    
                                    <Reports path="/reports" customerId={this.state.customerId} />
                                    {/* <ReportViewer path="/report-viewer" customerId={this.state.customerId} /> */}
                                    <BudgetReport path='/budget-report' customerId={this.state.customerId} />
                                    <ServiceManagement path="/service-management" customerId={this.state.customerId} />
                                    <Contracts path="/contracts" customerId={this.state.customerId} />
                                    <Budgets path="/budgets/" customerId={this.state.customerId} />
                                    <Triggers path="/triggers" customerId={this.state.customerId} />
                                    <ClosingPrices path="/closing-prices" customerId={this.state.customerId} />
                                    <UserManagement path="/user-management" customerId={this.state.customerId} />
                                    <CookiePolicy path="/CookiePolicy" />
                                    <DataMaps path="/datamaps" />
                                    <DataMapsAdmin path="/datamapsadmin" />
                                    
                                    <HHDataCentre path="/hhdatacentre" customerId={this.state.customerId}/>

                                    <Procurement path="/procurement" customerId={this.state.customerId}/>
                                    <LoginDomain exact path="/loginDomain"></LoginDomain>
                                    <LogoutPage exact path="/logout"></LogoutPage>

                                    <CotQueue exact path="/cotqueue"></CotQueue>
                                    <Route path="/about" component={AboutPage} />
                                    
                                    <ClientSelector path="/client-selection" onSelectedClient={this.onSelectedClient} />
                                    <SwitchUserClient path="/switchUserClient" onSelectedClient={this.onSelectedUserClient} />
                                    <Route path="*">
                                        <Redirect to={{ pathname: "/" }} />
                                    </Route>
                                    
                                    
                                </Switch>
                            </DefaultLayout>
                        ) : (
                            (this.state.isCustomerSSO === "true")
                                  ?
                                  <EmptyLayout>
                                <Switch>
                                  <Security oktaAuth={oktaAuth} restoreOriginalUri={this.restoreOriginalUri} >
                                    {/* <LoginSSO exact path ="/jllSSO" /> */}
                                    <Route path='/' exact={true} component={LoginSSO} />
                                    <Route path="/authcallback" component={LoginCallback} /> 

                                   
                                  </Security>
                                  </Switch>
                                </EmptyLayout>
                                :
                            <EmptyLayout>
                                <Switch>
                               
                                    <Login exact path="/" onUserAuthenticated={this.setupAuthState}
                                        customerId={this.state.customerId}
                                        siteId={this.state.siteId} userToken={this.state.userToken} />
                                    <LoginDomain exact path="/loginDomain"></LoginDomain>
                                    <PasswordChange exact path="/password-reset/:token" />
                                    <PasswordReset path="/password-reset" />
                                    <ClientSelector path="/client-selection" onSelectedClient={this.onSelectedClient} />
                                    <CookiePolicy path="/CookiePolicy" />
                                    <DiagnoseConnection path="/diagnoseconnection"/>

                                    <Route path="/login/callback" />
                                    <Route path="*">
                                        <Redirect to={{ pathname: "/" }} />
                                    </Route>
                                    

                                </Switch>
                            </EmptyLayout>
                           
                        )}
                    </Router>
                    </BreadcrumbProvider>
                    </StickyContainer>
                </div>
            </ MsalProvider>
        );
    }
}

export default withRouter(App);
